import Vue from 'vue';

export default function (store) {
  const { isLoggedIn } = store.getters;
  const isPaidUser = isLoggedIn && store.getters.paidUser;
  const isSeller = isLoggedIn && store.state.user?.roles?.isSeller;
  const isHasTeam = isLoggedIn && store.state.user?.has_team;

  const showWidget = !isSeller && (isPaidUser || isHasTeam);

  if (showWidget) {
    const root = new Vue();

    let isLoaded = false;
    root.isLoaded = () => isLoaded;

    root.load = () => {
      if (isLoaded) {
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.id = 'ze-snippet';
      script.src = 'https://static.zdassets.com/ekr/snippet.js?key=758e3004-dfac-4769-a587-76c751d464ec';

      delete window.zE;

      const first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);

      script.onload = () => {
        isLoaded = true;

        window.zE('messenger', 'loginUser', (callback) => {
          fetch('/api/v3/user/data/')
            .then(response => response.json())
            .then((responseJson) => {
              const zendeskJwt = responseJson?.support?.zendeskJwt;
              callback(zendeskJwt);
            })
            .catch((err) => {
              console.error('zendesk loginUser error', err);
              throw err;
            });
        });

        window.zE('messenger:on', 'unreadMessages', () => {
          fetch('/api/v3/account/sync-support-data/', {
            method: 'PUT',
          })
            .then(response => response.json())
            .catch((err) => {
              console.error('zendesk unreadMessages error', err);
              throw err;
            });
        });
      };
    };

    root.load();

    Object.defineProperty(root, 'zE', {
      get: function get() {
        return window.zE;
      },
    });
  }
}
